import React from "react";

export default function UserDetailEmpty() {
  return (
    <div className="au-detail-empty amf-detail-idle">
      <p className="amf-idle-eyebrow">Accounts desk</p>
      <h2 className="amf-idle-title">Select an account from the ledger</h2>
      <p className="amf-idle-copy">Balances, role, and member activity.</p>
    </div>
  );
}
